import React, { Suspense } from 'react';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { graphql } from 'babel-plugin-relay/macro';
import { get } from 'lodash';

import SelectField from 'components/SelectField';

import { SelectPreQualificationFormTemplateQuery } from './__generated__/SelectPreQualificationFormTemplateQuery.graphql';
// TODO: Fix any props, can't extend from the SelectField types synce its a .js
const SelectPreQualificationFormTemplate: React.FC<any> = (props) => {
  const response = useLazyLoadQuery<SelectPreQualificationFormTemplateQuery>(
    graphql`
      query SelectPreQualificationFormTemplateQuery {
        patientFormTemplateMany(filter: { type: preQualification }) {
          _id
          title
        }
      }
    `,
    {},
  );

  const formsFromResponse = get(response, 'patientFormTemplateMany') || [];
  const formatedForms = formsFromResponse.map((form) => ({ value: get(form, '_id'), label: get(form, 'title') }));
  const selectOptions = [{ labelOnly: 'None' }, ...formatedForms];

  return <SelectField {...props} options={selectOptions} placeholder="None" />;
};

export default (props: any) => (
  <Suspense fallback={<SelectField />}>
    <SelectPreQualificationFormTemplate {...props} />
  </Suspense>
);
